import Roles from "@src/constants/Roles";
import {
  ClinicUserRoles,
  ClinicUserStatuses,
} from "@src/constants/ClinicUserConstants";
import { User } from "@src/state/currentUserState";
import get from "lodash/get";

const PermissionLevelRanks = {
  view: 1,
  edit: 2,
} as const;

export const isSiteAdminRole = (roleSlug: string): boolean =>
  roleSlug === Roles.SiteAdmin;

export const getHasRole = (user: User, requiredRoleSlug: string): boolean => {
  if (
    user.role &&
    (user.role == requiredRoleSlug || isSiteAdminRole(user.role))
  ) {
    return true;
  }
  return false;
};

export const getHasPermission = (
  user: User,
  requiredPermissionSlug: string,
  requiredLevel: string,
): boolean => {
  if (isSiteAdminRole(user.role)) {
    // Site admins get everything
    return true;
  }

  const requiredRank = get(PermissionLevelRanks, requiredLevel);

  return user.permissions.some(
    (p) =>
      p.permission === requiredPermissionSlug &&
      get(PermissionLevelRanks, p.level) >= requiredRank,
  );
};

/**
 * True when the user is an active admin on their active clinic.
 * Used to gate the Clinic Settings surface (manage clinics / team).
 */
export const isClinicAdmin = (user: User | null | undefined): boolean => {
  if (!user || !user.activeClinic) return false;
  return !!user.clinicUsers?.some(
    (cu) =>
      cu.clinic.id === user.activeClinic?.id &&
      cu.role === ClinicUserRoles.Admin &&
      cu.status === ClinicUserStatuses.Active,
  );
};
